import {
  Avatar,
  Button,
  Divider,
  Drawer,
  Input,
  Layout,
  Menu,
  Typography,
} from "antd";
import React, { useState } from "react";
const { Header, Content, Footer } = Layout;
import "./landing.css";
import Logo from "@/assets/logo.jpeg";
import {
  Home,
  AppWindow,
  Camera,
  DollarSign,
  MessageSquare,
  HelpCircle,
  Menu as MenuIcon,
  ChevronRight,
  Gauge,
  LogIn,
  HomeIcon,
} from "lucide-react";
import {
  FAQSection,
  FeaturesSection,
  HomeSection,
 } from "./components/MainPages";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
const { Search } = Input;

const LandingLayout = () => {
  const { authenticated } = useAuth();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentSection, setCurrentSection] = useState("1");
  const navigate = useNavigate();
  const renderSection = () => {
    switch (currentSection) {
      case "1":
        return (
          <>
            <HomeSection />
            <FeaturesSection />
            <FAQSection />
          </>
        );
      case "2":
        return <FeaturesSection />;
      case "3":
        return <FAQSection />;
      default:
        return <HomeSection />;
    }
  };

  const items1 = [
    { key: "1", icon: <Home size={18} />, label: "Home" },
    { key: "2", icon: <AppWindow size={18} />, label: "Feature" },
     { key: "3", icon: <HelpCircle size={18} />, label: "FAQ" },
  ].map((item) => ({
    key: item.key,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {item.icon}
        <span>{item.label}</span>
      </div>
    ),
  }));

  return (
    <Layout className="d-flex flex-column min-vh-100">
      <Header className="landing-header">
        <div className="d-flex flex-column align-items-center p-1 rounded">
          <Gauge size={20} className="text-white" />
          <div
            className="text-white m-0 p-0"
            style={{ lineHeight: "1rem", fontSize: "0.85rem" }}
          >
            Edkas
          </div>
        </div>

        <Typography.Title level={5} className="title" style={{fontSize:"16px !important"}}>
          SEA FLASH
        </Typography.Title>

        <div className="desktop-menu">
          <Menu
            mode="horizontal"
            selectedKeys={[currentSection]}
            onClick={(e) => setCurrentSection(e.key)}
            className="bg-transparent   d-flex justify-content-start w-100"
          >
            {items1.map((item) => (
              <Menu.Item
                key={item.key}
                className="d-flex align-items-center px-4"
                style={{ borderRadius: "6px" }}
              >
                <span
                  className={`${
                    item.key != currentSection ? "text-white" : ""
                  }`}
                >
                  {" "}
                  {item.label}
                </span>
              </Menu.Item>
            ))}
          </Menu>
        </div>

        {/* Mobile Hamburger */}
        <div className="mobile-menu-icon">
          <MenuIcon
            size={24}
            onClick={() => setDrawerOpen(true)}
            color="white"
          />
        </div>
        {authenticated ? (
          <Button
            icon={<HomeIcon size={20} className="mt-4" />}
            className="bg-white rounded-2 me-3"
            onClick={() => navigate("/login")}
          >
            App Dashboard
          </Button>
        ) : (""
        )}

        <Drawer
          title="Menu"
          placement="right"
          onClose={() => setDrawerOpen(false)}
          open={drawerOpen}
        >
          <Menu
            mode="vertical"
            items={items1}
            selectedKeys={[currentSection]}
          />
          <Button type="primary" style={{ marginTop: 16 }} block>
            Login
          </Button>
        </Drawer>
      </Header>

      <Content className="pt-5 pt-md-4">{renderSection()}</Content>

      <Footer
        className="text-white mt-auto"
        style={{ backgroundColor: "#289E80" }}
      >
        <div className="container py-5">
          <div className="row g-4">
            <div className="col-12 col-md-3">
              <h3 className="fs-4 fw-bold mb-3 fst-italic d-flex align-items-center">
                SEA FLASH
              </h3>
              <p className="mb-3">
                The complete solution for modern businesses looking to
                streamline operations and boost productivity.
              </p>
            </div>
          </div>

          <hr className="border-light my-4" />

          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center">
            <p className="mb-0">© 2025 AppName. All rights reserved.</p>
          </div>
        </div>
      </Footer>
    </Layout>
  );
};

export default LandingLayout;
